<!--
 * @Author: ZhaoG
 * @Date: 2026-03-16 09:44:57
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-26 14:10:11
 * @FilePath: \sra-fe\src\views\register\material\maPerfectInfo\greenLowCarbonPreview.vue
 * @Description: 绿色低碳
-->
<template>
  <!-- 绿色低碳 -->
  <div class="sign-content">
    <el-card-title :title="title" />
    <el-form label-width="80px" :model="cooperationForm" ref="cooperationFormRef">
      <!-- /* 企业是否设计绿色低碳管理：0 - 否；1 - 是 */ -->
      <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenLowCarbon')" label-width="400px"
        prop="greenCarbonManageFlag">
        <!-- 本企业是否涉及绿色低碳管理 -->
        {{
          cooperationForm.greenCarbonManageFlag == "1"
            ? $t("page.greenLowCarbon.contentLabel.isYes")
            : $t("page.greenLowCarbon.contentLabel.isNo")
        }}
      </el-form-item>
      <!--     /* 绿色低碳类型：1 - 不选择；2 - 水泥；3 - 钢材；4 - 沥青 */ -->
      <el-form-item :label="$t('page.greenLowCarbon.contentLabel.changeCategory')" label-width="400px"
        v-if="cooperationForm.greenCarbonManageFlag == '1'" prop="greenCarbonType">
        <!-- 请选择类别 -->
        {{ cooperationForm.greenCarbonType }}
      </el-form-item>
      <template v-if="cooperationForm.greenCarbonManageFlag == '1'">
        <el-card-title :title="title1" />
        <!-- /* 是否获得绿色工厂认证（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenProduction')" label-width="400px"
          :aria-hidden="false" prop="greenFactoryFlag">
          <!-- 是否获得绿色工厂认证 -->
          {{
            cooperationForm.greenFactoryFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!--  /* 绿色工厂认证级别：7 - 市级；8 - 省级；9 - 国家级 */ -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.greenFactoryCertificationLevel'
        )
          " label-width="400px" v-if="cooperationForm.greenFactoryFlag == '1'" prop="greenFactoryLevel">
          <!-- 绿色工厂认证等级 -->
          {{ cooperationForm.greenFactoryLevel }}
        </el-form-item>
        <!-- /* 绿色工厂认证证书 */  greenFactoryFiles -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.greenFactoryCertificationFile')
          " label-width="400px" v-if="cooperationForm.greenFactoryFlag == '1'" prop="greenFactoryFiles">
          <!-- 自定义文件列表表格 - 绿色工厂 -->
          <el-table v-if="cooperationForm.greenFactoryFiles.length > 0" :data="cooperationForm.greenFactoryFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="previewFile(scope.row, 'green')">{{
                  $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!-- /* 是否获得零碳工厂认证（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.isZeroCarbonFactoryCertification'
        )
          " label-width="400px" prop="zeroFactoryFlag">
          <!-- 是否获得零碳工厂认证 -->
          {{
            cooperationForm.zeroFactoryFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!--   /* 零碳工厂认证级别：3 - 三星；4 - 四星；5 - 五星；6 - 六星 */ -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.isZeroCarbonFactoryCertificationRating'
        )
          " label-width="400px" v-if="cooperationForm.zeroFactoryFlag == '1'" prop="zeroFactoryLevel">
          <!-- 零碳工厂认证等级 -->
          {{ cooperationForm.zeroFactoryLevel }}
        </el-form-item>
        <!-- /* 零碳工厂认证证书 */ zeroFactoryFiles -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.ZeroCarbonFactoryCertificationRatingFile'
        )
          " label-width="400px" v-if="cooperationForm.zeroFactoryFlag == '1'" prop="zeroFactoryFiles">
          <!-- 自定义文件列表表格 - 零碳工厂 -->
          <el-table v-if="cooperationForm.zeroFactoryFiles.length > 0" :data="cooperationForm.zeroFactoryFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="previewFile(scope.row, 'zero')">{{
                  $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!-- /* 是否通过企业清洁生产审核（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.isEnterprisesPassTheCleanProductionAudit'
        )
          " label-width="400px" prop="cleanProductionFlag">
          <!-- 是否通过企业清洁生产审核 -->
          {{
            cooperationForm.cleanProductionFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!--  /* 清洁生产审核报告（备案本） */ cleanProductionFiles -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.EnterprisesPassTheCleanProductionAuditFile'
        )
          " label-width="400px" v-if="cooperationForm.cleanProductionFlag == '1'" prop="cleanProductionFiles">
          <el-table v-if="cooperationForm.cleanProductionFiles.length > 0" :data="cooperationForm.cleanProductionFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="previewFile(scope.row, 'clean')">{{
                  $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!-- 类别为水泥 新增以下选项 -->
        <template v-if="cooperationForm.greenCarbonType == '2'">
          <!-- /* 水泥 - 是否使用新型干法等环保性生产工艺（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isEnvironmentallyFriendlyProductionProcess'
          )
            " label-width="400px" prop="cementCraftFlag">
            <!-- 是否使用新型干法等环保性生产工艺 -->
            {{
              cooperationForm.cementCraftFlag == "1"
                ? $t("page.greenLowCarbon.contentLabel.isYes")
                : $t("page.greenLowCarbon.contentLabel.isNo")
            }}
          </el-form-item>
          <!--/* 是否使用新型干法（附件） */ cementCraftFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.EnvironmentallyFriendlyProductionProcessFile'
          )
            " label-width="400px" v-if="cooperationForm.cementCraftFlag == '1'"
            prop="cementCraftFiles">
            <el-table v-if="cooperationForm.cementCraftFiles.length > 0" :data="cooperationForm.cementCraftFiles" style="width: 100%; margin-top: 10px"
              border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'production')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>

        <!-- 类别为钢筋 新增以下选项 -->
        <template v-if="cooperationForm.greenCarbonType == '3'">
          <!-- /* 钢材 - 单位产品能源消耗量 */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isProductEnergyConsumption')
            " label-width="400px" prop="steelEnergyConsumptionValue">
            <!-- 轧钢单位产品能源消耗量 -->
            {{ cooperationForm.steelEnergyConsumptionValue }}
            <span>kgce/t</span>
          </el-form-item>
          <!-- /* 钢材 - 单位产品能源消耗量（附件） */ steelEnergyConsumptionFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.ProductEnergyConsumptionFile'
          )
            " label-width="400px" prop="ProductEnergyConsumptionFile">
            <el-table v-if="cooperationForm.steelEnergyConsumptionFiles.length > 0"
              :data="cooperationForm.steelEnergyConsumptionFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'energy')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>

        <!-- 类别为沥青 新增以下选项 -->
        <template v-if="cooperationForm.greenCarbonType == '4'">
          <!--  /* 沥青 - 单位产品能源消耗量 */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.isAsphaltProductEnergyConsumption'
          )
            " label-width="400px" prop="asphaltEnergyConsumptionValue">
            <!-- 轧钢单位产品能源消耗量 -->
            {{ cooperationForm.asphaltEnergyConsumptionValue }}
            <span>kgce/t</span>
          </el-form-item>
          <!--/* 沥青 - 单位产品能源消耗量（附件） */ asphaltEnergyConsumptionFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.AsphaltProductEnergyConsumptionFile'
          )
            " label-width="400px" prop="AsphaltProductEnergyConsumptionFile">
            <el-table v-if="cooperationForm.asphaltEnergyConsumptionFiles.length > 0"
              :data="cooperationForm.asphaltEnergyConsumptionFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'Asphalt')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>

        <!-- 绿色产品 -->
        <el-card-title :title="title2" />
        <addGreenProducts  :temGreenInfo="temGreenInfo"></addGreenProducts>

        <!-- 类别为水泥 新增以下选项 -->
        <template v-if="cooperationForm.greenCarbonType == '2'">
          <!-- /* 水泥 - 是否采用原材料替代等资源循环利用方式（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.AdoptingMethodsOfResourceRecyclingSuchAsRawMaterialSubstitution'
          )
            " label-width="400px" prop="cementRecyclingFlag">
            {{
              cooperationForm.cementRecyclingFlag == "1"
                ? $t("page.greenLowCarbon.contentLabel.isYes")
                : $t("page.greenLowCarbon.contentLabel.isNo")
            }}
          </el-form-item>
          <!--  /* 水泥 - 原材料替代率（百分比） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.RawMaterialSubstitutionRate')
            " label-width="400px" prop="cementRecyclingValue" v-if="cooperationForm.cementRecyclingFlag == '1'">
            {{ cooperationForm.cementRecyclingValue }}
            <span>%</span>
          </el-form-item>
          <!-- /* 水泥 - 原材料替代率（附件） */ cementRecyclingFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.productionRawMaterialSubstitutionRate'
          )
            " label-width="400px" v-if="cooperationForm.cementRecyclingFlag == '1'"
            prop="productionRawMaterialSubstitutionRate">
            <el-table v-if="cooperationForm.cementRecyclingFiles.length > 0"
              :data="cooperationForm.cementRecyclingFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'Calculation')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>

        <!-- 类别为钢筋 新增以下选项 -->
        <template v-if="cooperationForm.greenCarbonType == '3'">
          <!-- /* 钢材 - 是否对轧钢过程进行废钢余料回收再利用（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.steelRollingProcess')" label-width="400px"
            prop="steelRecyclingFlag">
            {{
              cooperationForm.steelRecyclingFlag == "1"
                ? $t("page.greenLowCarbon.contentLabel.isYes")
                : $t("page.greenLowCarbon.contentLabel.isNo")
            }}
          </el-form-item>
          <!-- /* 钢材 - 是否对轧钢过程进行废钢余料回收再利用（附件） */steelRecyclingFiles -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.ScrapSteelRecyclingPlanFile')
            " label-width="400px" v-if="cooperationForm.steelRecyclingFlag == '1'" prop="ScrapSteelRecyclingPlanFile">
            <el-table v-if="cooperationForm.steelRecyclingFiles.length > 0" :data="cooperationForm.steelRecyclingFiles"
              style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'steelRollingProcess')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>

        <!-- 类别为沥青 新增以下选项 -->
        <template v-if="cooperationForm.greenCarbonType == '4'">
          <!-- /* 沥青 - 是否对沥青生产原材料进行回收利用（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.IsRecyclingOfRawMaterialsForAsphaltProductionConducted'
          )
            " label-width="400px" prop="asphaltRecyclingFlag">
            {{
              cooperationForm.asphaltRecyclingFlag == "1"
                ? $t("page.greenLowCarbon.contentLabel.isYes")
                : $t("page.greenLowCarbon.contentLabel.isNo")
            }}
          </el-form-item>
          <!-- /* 沥青 - 原材料回收利用率（百分比） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.RawMaterialRecyclingAndUtilizationRate'
          )
            " label-width="400px" prop="asphaltRecyclingValue" v-if="cooperationForm.asphaltRecyclingFlag == '1'">
            <!-- 轧钢单位产品能源消耗量 -->
            {{ cooperationForm.asphaltRecyclingValue }}
            <span>%</span>
          </el-form-item>
          <!-- /* 沥青 - 原材料回收利用率（附件） */asphaltRecyclingFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.CalculationSheetForRawMaterialRecyclingUtilizationRate'
          )
            " label-width="400px" v-if="cooperationForm.asphaltRecyclingFlag == '1'"
            prop="CalculationSheetForRawMaterialRecyclingUtilizationRate">
            <el-table v-if="cooperationForm.asphaltRecyclingFiles.length > 0"
              :data="cooperationForm.asphaltRecyclingFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'CalculationSheet')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <!-- /* 沥青 - 是否对废沥青生产原材料进行回收利用（1 - 是/0 - 否） */ -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.IsWasteAsphaltRecycledAndReused'
          )
            " label-width="400px" prop="asphaltWasteRecyclingFlag">
            <!-- 是否使用新型干法等环保性生产工艺 -->
            {{
              cooperationForm.asphaltWasteRecyclingFlag == "1"
                ? $t("page.greenLowCarbon.contentLabel.isYes")
                : $t("page.greenLowCarbon.contentLabel.isNo")
            }}
          </el-form-item>
          <!-- /* 沥青 - 废沥青回收利用率（百分比） */ -->
          <el-form-item :label="$t('page.greenLowCarbon.contentLabel.RecyclingRateOfWasteAsphalt')
            " label-width="400px" prop="asphaltWasteRecyclingValue" v-if="cooperationForm.asphaltWasteRecyclingFlag == '1'">
            <!-- 轧钢单位产品能源消耗量 -->
            {{ cooperationForm.asphaltWasteRecyclingValue }}
            <span>%</span>
          </el-form-item>
          <!-- /* 沥青 - 原材料回收利用率（附件） */ asphaltWasteRecyclingFiles -->
          <el-form-item :label="$t(
            'page.greenLowCarbon.contentLabel.recyclingTaxRefundSupportingDocuments'
          )
            " label-width="400px" v-if="cooperationForm.asphaltWasteRecyclingFlag == '1'"
            prop="recyclingTaxRefundSupportingDocuments">
            <el-table v-if="cooperationForm.asphaltWasteRecyclingFiles.length > 0"
              :data="cooperationForm.asphaltWasteRecyclingFiles" style="width: 100%; margin-top: 10px" border>
              <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
              <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
              <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
                <template slot-scope="scope">
                  <el-button type="text" @click="previewFile(scope.row, 'recyclingTax')">{{
                    $t("page.greenLowCarbon.table.preview") }}</el-button>
                    <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>

        <!-- 绿色物流 -->
        <el-card-title :title="title3" />
        <!-- /* 是否获得绿色物流认证（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenLogistics')" label-width="400px"
          prop="logisticsCertificationFlag">
          <!-- 是否获得绿色物流认证 -->
          {{
            cooperationForm.logisticsCertificationFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!-- /* 绿色物流认证级别：1 - 一星；2 - 二星；3 - 三星 */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenProductionRating')
          " label-width="400px" v-if="cooperationForm.logisticsCertificationFlag == '1'"
          prop="logisticsCertificationLevel">
          {{ cooperationForm.logisticsCertificationLevel }}
        </el-form-item>
        <!--/* 绿色物流认证级别（附件） */ logisticsCertificationFiles -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.greenLogisticsFile')" label-width="400px"
          v-if="cooperationForm.logisticsCertificationFlag == '1'" prop="logisticsCertificationFiles">
          <!-- 自定义文件列表表格 - 绿色工厂 -->
          <el-table v-if="cooperationForm.logisticsCertificationFiles.length > 0"
            :data="cooperationForm.logisticsCertificationFiles" style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="previewFile(scope.row, 'greenLogisticsFile')">{{
                  $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- /* 是否使用了智能仓储管理技术（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isSmartWarehouse')" label-width="400px"
          prop="smartWarehouseFlag">
          <!-- 是否Smart Warehouse -->
          {{
            cooperationForm.smartWarehouseFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!--  /* 是否使用了智能仓储管理技术（附件） */ smartWarehouseFiles-->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.SmartWarehouseFile')" label-width="400px"
          v-if="cooperationForm.smartWarehouseFlag == '1'" prop="smartWarehouseFiles">
          <!-- 自定义文件列表表格 - 绿色工厂 -->
          <el-table v-if="cooperationForm.smartWarehouseFiles.length > 0" :data="cooperationForm.smartWarehouseFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="previewFile(scope.row, 'SmartWarehouseFile')">{{
                  $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!-- 绿色包装 -->
        <!-- /* 是否使用了绿色包装管理技术（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenPackaging')" label-width="400px"
          prop="greenPackageFlag">
          <!-- 是否Smart Warehouse -->
          {{
            cooperationForm.greenPackageFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!-- /* 是否使用了绿色包装管理技术（附件） */ greenPackageFiles -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenPackagingFile')" label-width="400px"
          v-if="cooperationForm.greenPackageFlag == '1'" prop="greenPackageFiles">
          <el-table v-if="cooperationForm.greenPackageFiles.length > 0" :data="cooperationForm.greenPackageFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="previewFile(scope.row, 'isGreenPackagingFile')">{{
                  $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!-- 绿色运输方式 -->
        <!--  /* 是否对产品使用新能源车辆进行运输（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenTransportationMode')
          " label-width="400px" prop="greenTransportationFlag">
          <!-- 是否对产品使用新能源车辆进行运输 -->
          {{
            cooperationForm.greenTransportationFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!-- 新能源车辆运输占比 -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.isGreenTransportationModeRating'
        )
          " label-width="400px" v-if="cooperationForm.greenTransportationFlag == '1'" prop="greenTransportationValue">
          {{ cooperationForm.greenTransportationValue }}
          <span>%</span>
        </el-form-item>
        <!-- /* 是否对产品使用新能源车辆进行运输（附件） */ greenTransportationFiles-->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isGreenTransportationModeFile')
          " label-width="400px" v-if="cooperationForm.greenTransportationFlag == '1'" prop="greenTransportationFiles">
          <el-table v-if="cooperationForm.greenTransportationFiles.length > 0"
            :data="cooperationForm.greenTransportationFiles" style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="
                  previewFile(scope.row, 'isGreenTransportationModeFile')
                  ">{{ $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <!-- 碳管理 -->
        <el-card-title :title="title4" />
        <!-- 碳管理制度规划 -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isTopLevelCarbonManagement')
          " label-width="400px" prop="carbonManageFlag">
          <!-- 是否Smart Warehouse -->
          {{
            cooperationForm.carbonManageFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!--  /* 是否制定顶层碳管理制度规划（附件） */ carbonManageFiles -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.isTopLevelCarbonManagementFile'
        )
          " label-width="400px" v-if="cooperationForm.carbonManageFlag == '1'" prop="carbonManageFiles">
          <el-table v-if="cooperationForm.carbonManageFiles.length > 0" :data="cooperationForm.carbonManageFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="
                  previewFile(scope.row, 'isTopLevelCarbonManagementFile')
                  ">{{ $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 碳减排措施 -->
        <!-- /* 是否使用碳减排措施实现主体减排降碳（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.isCarbonEmissionReductionMeasures'
        )
          " label-width="400px" prop="carbonEmissionFlag">
          {{
            cooperationForm.carbonEmissionFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!-- /* 是否使用碳减排措施实现主体减排降碳（附件） */ carbonEmissionFiles-->
        <el-form-item :label="$t(
          'page.greenLowCarbon.contentLabel.isCarbonEmissionReductionMeasuresFile'
        )
          " label-width="400px" v-if="cooperationForm.carbonEmissionFlag == '1'" prop="carbonEmissionFiles">
          <!-- 自定义文件列表表格 - 绿色工厂 -->
          <el-table v-if="cooperationForm.carbonEmissionFiles.length > 0" :data="cooperationForm.carbonEmissionFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="
                  previewFile(
                    scope.row,
                    'isCarbonEmissionReductionMeasuresFile'
                  )
                  ">{{ $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 碳抵消手段 -->
        <!-- /* 是否使用碳抵消措施实现主体减排降碳（1 - 是/0 - 否） */ -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isCarbonOffsetMeasures')" label-width="400px"
          prop="carbonOffsetFlag">
          <!-- 是否使用碳减排措施实现主体减排降碳 -->
          {{
            cooperationForm.carbonOffsetFlag == "1"
              ? $t("page.greenLowCarbon.contentLabel.isYes")
              : $t("page.greenLowCarbon.contentLabel.isNo")
          }}
        </el-form-item>
        <!-- /* 是否使用碳抵消措施实现主体减排降碳（附件） */ carbonOffsetFiles -->
        <el-form-item :label="$t('page.greenLowCarbon.contentLabel.isCarbonOffsetMeasuresFile')
          " label-width="400px" v-if="cooperationForm.carbonOffsetFlag == '1'" prop="carbonOffsetFiles">
          <el-table v-if="cooperationForm.carbonOffsetFiles.length > 0" :data="cooperationForm.carbonOffsetFiles"
            style="width: 100%; margin-top: 10px" border>
            <el-table-column prop="fileName" :label="$t('page.greenLowCarbon.table.fileName')" />
            <el-table-column prop="fileSize" :label="$t('page.greenLowCarbon.table.fileSize')" width="120" />
            <el-table-column :label="$t('page.greenLowCarbon.table.operation')" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="previewFile(scope.row, 'carbonOffsetFiles')">{{
                  $t("page.greenLowCarbon.table.preview") }}</el-button>
                  <el-button type="text" @click="downloadFile(scope.row)">{{
                    $t("page.greenLowCarbon.table.download") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>

import { getPreviewUrl } from "@/utils";
import addGreenProducts from "./addGreenProductsPreview";

export default {
  name: "historyCooperation",
  components: { addGreenProducts },
  data() {
    return {
      title: window.$t("page.greenLowCarbon.contentTitle.greenLowCarbon"), // 绿色低碳
      title1: window.$t("page.greenLowCarbon.contentTitle.greenProduction"), // 绿色生产,
      title2: window.$t("page.greenLowCarbon.contentTitle.greenProducts"), // 绿色产品,
      title3: window.$t("page.greenLowCarbon.contentTitle.greenLogistics"), // 绿色物流,
      title4: window.$t("page.greenLowCarbon.contentTitle.carbonManagement") // 碳管理,
    };
  },
  props: {
    cooperationForm: {
      type: Object,
      default() {
        return {};
      }
    },
    temGreenInfo: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    //预览
    async previewFile({ uploadId,uploadIdStr }) {
      if (uploadIdStr) {
        getPreviewUrl(uploadIdStr);
      }else{
        getPreviewUrl(uploadId);
      }
    },
    // 下载文件
    downloadFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sra/reg/users/signup/downloadByFileUrl?fileUrl=${
        row.ossUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
  }
};
</script>

<style scoped lang="scss">
.sign-content {
  // width: 1180px;
  background: #ffffff;
  margin: 20px auto;
  // overflow: hidden;

  .el-form {
    margin-top: 20px;
    //margin-left: 250px;
    position: relative;

    .el-textarea {
      margin-left: 6px;
      width: 430px;
      border-radius: 4px;

      /deep/ .el-textarea__inner {
        height: 58px;
      }
    }

    .upload-demo /deep/ .el-button {
      padding-top: 8px;
    }

    .el-table {
      width: 585px;
      margin: 40px auto;

      /deep/ .el-table__row {
        .el-input {
          input {
            background-color: #f1f1f1 !important;
            color: #9b9b9b !important;
          }
        }

        .cooperation .el-input__inner {
          padding-right: 60px;
        }
      }
    }

    .addbtn {
      position: absolute;
      left: 790px;

      /deep/ .icon-ccui-add {
        margin-right: 10px;
        color: #ff142f;
      }

      /deep/ span {
        color: #ff142f;
      }
    }
  }
}

.btn {
  width: 300px;
  height: 40px;
  background: #ff142f;
  margin-bottom: 20px;

  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}

.btnBox {
  margin: 0px auto;
  width: 500px;
}

.cooperationRuls {
  .el-form-item__error {
    width: 100%;
    text-align: center;
  }
}
</style>
